import { createFileRoute } from '@tanstack/react-router';

import { DomainsPage } from '../../pages/settings';

export const Route = createFileRoute('/_shell/settings/domains')({
  component: DomainsPage,
});
